import { Blockchain } from "@rarible/api-client"
import { defineChain } from "viem"
import { toCurrencyId } from "../../../price/types"
import { FEE_CONFIG_URL } from "../constants"
import type { StaticEthereumBlockchainConfig } from "../types"

const megaeth = defineChain({
  id: 4326,
  name: "MegaETH",
  nativeCurrency: {
    decimals: 18,
    name: "Ethereum",
    symbol: "ETH",
  },
  rpcUrls: {
    default: { http: ["https://mainnet.megaeth.com/rpc"] },
  },
  blockExplorers: {
    default: {
      name: "MegaETH Explorer",
      url: "https://megaeth.blockscout.com/",
    },
  },
  testnet: false,
})

export const megaEthConfig: StaticEthereumBlockchainConfig = {
  name: "MegaETH",
  icon: "/images/blockchains/mega-eth.svg",
  isEvm: true,
  testnet: false,
  isTestnet: false,
  feesVersion: "v3",
  treasury: "0x64d34BcfC32Fb663172C47d6E4Fb1dBFaba6e7a2",
  unionApi: "https://api.rarible.org",
  basePath: "https://megaeth-api.rarible.org",
  chainId: 4326,
  blockchain: Blockchain.MEGAETH,
  chainName: "MegaETH",
  exchange: {
    v2: "0x2c46e116a742C159fa79e2717b50759EC979e3Be",
    wrapper: "0x4421b444955b50e57fa2F73656A5bD1E23F9B9e5",
  },
  blockExplorers: [
    {
      url: "https://megaeth.blockscout.com",
      icon: "/images/scanner.svg",
      adress: "https://megaeth.blockscout.com/address/${adrress}",
    },
  ],
  rpcUrls: [{ url: "https://mainnet.megaeth.com/rpc", isPublic: true }],
  privateRpcNodeSlug: "megaeth-node",
  transferProxies: {
    nft: "0x892f0e3DEaC041b12b748bf9d7D1BA480d266696",
    erc721Lazy: "0x147d06FbDA085C0455615E554D87262B0726ad0c",
    erc20: "0x12181eDedD1f81838580668bb5B50e1030df4667",
  },
  feeConfigUrl: FEE_CONFIG_URL,
  primaryCurrency: {
    id: toCurrencyId("MEGAETH:0x0000000000000000000000000000000000000000"),
    symbol: "ETH",
    name: "ETH",
    decimals: 18,
  },
  wrappedCurrency: {
    id: toCurrencyId("MEGAETH:0x4200000000000000000000000000000000000006"),
    symbol: "WETH",
    name: "WETH",
    decimals: 18,
  },
  addFundsLink: "",
  hasStabilityProtocol: false,
  viem: megaeth,
}

export const getMegaEthConfig = (): StaticEthereumBlockchainConfig =>
  megaEthConfig
